import Postgrest from '@/store/Postgrest.vue'
import { IterateeShorthand } from 'lodash'
import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'

import SaveButtons from './SaveButtons.vue'

export default Vue.extend({
  components: { Postgrest, SaveButtons },
  computed: {
    case_id(): string {
      return this.caseId || this.$store.getters.currentCaseId
    },
    where(): IterateeShorthand<{ case_id: string }> {
      return { case_id: this.case_id }
    },
  },
  methods: {
    stamp(exercise: any) {
      return {
        case_id: this.case_id,
        submitter_id: this.$store.getters.currentUserId,
        ...exercise,
      }
    },
    publish(save: (any) => any, exercise: any) {
      if (
        window.confirm(
          (this.$t('exercises.confirmSend') as string) || 'Are you sure? Not editable afterwards'
        )
      ) {
        save({
          ...this.stamp(exercise),
          published_at: new Date(),
        }).then(result => {
          this.$emit('published', result)
        })
      }
    },
  },
  props: {
    caseId: {
      default: null,
      type: String,
    },
    editable: {
      default: true,
      type: Boolean,
    },
  },
})
